/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Removed_Line_InvalidInputs */

const vi_einvoice_draft_removed_line_invalid = /** @type {(inputs: Einvoice_Draft_Removed_Line_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng hàng cần xóa không còn trong bản nháp. Vui lòng đóng và mở lại phần sửa hóa đơn rồi thử lại.`)
};

/**

* @param {Einvoice_Draft_Removed_Line_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_removed_line_invalid = /** @type {((inputs?: Einvoice_Draft_Removed_Line_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Removed_Line_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_removed_line_invalid(inputs)
});